import classNames from 'classnames';

import {BUTTON_VARIANT, Button} from '@time-webkit/all/atoms/button';

import type {PressEvent} from '@react-types/shared';
import {browserHistory} from 'utils/browser_history';

import type {Props as ButtonProps} from '@time-webkit/all/atoms/button/src/types';
import {TypographySize, useTypography} from '@time-webkit/all/hooks/typography';

type Props = {
    children: React.ReactNode;
    to?: string;
    href?: string;
}

// ButtonLink - deprecated, так как убрана из нашей дизайн-системы
export const ButtonLink: React.FC<Props & ButtonProps> = ({children, to, href, className, ...restProps}) => {
    const [textCls] = useTypography([
        {
            size: TypographySize.BodyL,
        },
    ]);

    const handleClick = (e: PressEvent) => {
        if (href) {
            window.location.href = href;
        } else if (to) {
            browserHistory.push(to);
        }

        restProps.onPress?.(e);
    };

    return (
        <Button
            className={classNames(textCls, className)}
            variant={BUTTON_VARIANT.TERTIARY}
            {...restProps}
            onPress={handleClick}
        >
            {children}
        </Button>
    );
};
